import { api } from './api';

const getVouGroupList = async () => {
    const response = await api({
        url: `Vous/getVouGroupList`,
        method: 'GET',
    });
    return response.data;
};

const getVouList = async () => {
    const response = await api({
        url: `Vous/getList`,
        method: 'GET',
    });
    return response.data;
};

const vousServices = {
  getVouGroupList,
  getVouList,
};

export default vousServices;
